import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function ChevronLeft({ idVariant = '', className }: Props) {
  return (
    <IconBase name="chevron-left" w={24} className={className}>
      <path fillRule="evenodd" clipRule="evenodd" d="M10.0607 12L15.2071 17.1464L14.5 17.8536L8.64645 12L14.5 6.14645L15.2071 6.85355L10.0607 12Z" fill="currentColor"/>
    </IconBase>
  )
}

export default ChevronLeft
